import { loadingAsyncState } from "widgets-for-react";
import { EditorState } from "draft-js";
export const initialState = (api)=>({
        reactions: loadingAsyncState(api.getReactions),
        editorState: EditorState.createEmpty(),
        authorEmail: "",
        authorScreenName: "",
        validationMessages: [],
        submitting: false
    });
